/*
 * Bootstrap Select directive
 * Version 1.0.0
 * Octave
 **/

(function () {
  'use strict';

  angular
    .module('directive.bootstrap-select', [])

    /* @ngInject */
    .factory('SelectpickerService', ["Environment", function (Environment) {
      var _mobile,
        load,
        queue = [];

      var service = {
        add: add
      };
      return service;

      ////////////

      function add(element, mobile) {
        _mobile = mobile;
        if (angular.isUndefined($.fn.selectpicker)) {
          queue.push(element);
          if (!load) {
            load = true;
            $.ajax({
              url: Environment === 'dev' ? '/js/bootstrap-select.js' : '/js/bootstrap-select.min.js',
              dataType: 'script',
              cache: true,
              success: function () {
                start();
              }
            });
          }
        } else {
          init(element);
        }
      }

      function start() {
        _.each(queue, function (element) {
          init(element);
        });
      }

      function init(element) {
        element.selectpicker({
          mobile: _mobile
        });
      }
    }])

    /* @ngInject */
    .directive('selectpicker', ["$timeout", "SelectpickerService", function ($timeout, SelectpickerService) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
          scope.$eval(attrs.ngModel + '="' + element.val() + '"');

          SelectpickerService.add(element, scope.device ? scope.device.mobile : false);

          if (attrs.ngModel) {
            var unwatch = scope.$watch(attrs.ngModel, function () {
              $timeout(function () {
                if (angular.isDefined(element.selectpicker)) {
                  element.selectpicker('refresh');
                }
              });
            }, true);
          }

          scope.$on('$destroy', function () {
            if (angular.isDefined(element.selectpicker)) {
              element.selectpicker('destroy');
            }
            if (unwatch) {
              unwatch();
            }
          });
        }
      };
    }]);

})();
